/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Category from '@/model/dataLayer/api/dish/Category'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'
import { orderBy } from 'lodash-es'

const entity = {
  code: {
    displayName: 'ProductNr'
  },
  name: {
    displayName: 'name'
  },
  categoryId: {
    displayName: 'labelName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Category.getList,
        itemText: '_langsname',
        multiple: true
      }
    }
  },
  categoryTypeId: {
    displayName: 'TaxRate',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: CategoryType.getList
      }
    }
  },
  price: {
    displayName: 'price',
    type: IKDataEntity.Types.Float
  },
  totalCount: {
    displayName: 'total'
  }
}
const config = {
  name: () => {
    return '123'
  },
  load: async function (filter) {
    const data = {
      start: filter[0].dateFilter[0],
      end: filter[0].dateFilter[1]
    }
    const res = orderBy((await hillo.get('BackendData.php', Object.assign({
      op: 'dishStatistic',
      lang: GlobalSettings.getLang()
    }, data)))
      .content, ['totalCount'], ['desc'])
    console.log(res)
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
